import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import Answer from 'src/components/atoms/wizard/Answer'
import { StoreProps } from 'src/stores'

interface State {
  valid: boolean
  noRedirect: boolean
}

const nudges = new Map([
  ['PREPARED', 'Wir helfen Ihnen dabei, Ihre Wünsche festzuhalten.'],
  [
    'INSURANCE_SET',
    'Bei uns können Sie Ihre Bestattungsvorsorge mit einer bereits bestehenden Sterbegeldversicherung verknüpfen.'
  ],
  [
    'STARTING',
    'Wir helfen Ihnen Schritt für Schritt zu Ihrer Bestattungsvorsorge.'
  ]
])

@inject('wizardStore')
@observer
export class TimeFrameInput extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.provision.timeFrame,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionTimeFrame' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_provisionTimeFrame' })
  }

  decideNudge = () => {
    const { wizardStore } = this.props
    return nudges.get(wizardStore.provision.progress)
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    if (key === wizardStore.provision.timeFrame) {
      wizardStore.provision.timeFrame = null
      this.setState({ valid: false })
    } else {
      wizardStore.provision.timeFrame = key
      this.setState({ valid: true })
    }
  }

  renderAnswer = (text, id) => {
    const { wizardStore } = this.props
    return (
      <Answer
        answerKey={id}
        checked={wizardStore.provision.timeFrame === id}
        onClick={() => this.handleAnswerClick(id)}>
        {text}
      </Answer>
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    const answer1 = 'So bald als möglich'
    const answer2 = 'In den nächsten Wochen'
    const answer3 = 'In den nächsten Monaten'
    const answer4 = 'Ich weiß es noch nicht'
    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={65} end={80}>
              <p>
                <i className='fas fa-check'></i>
                {this.decideNudge()}
              </p>
            </ProgressBar>
          </ProgressBarContainerWizard>
          <Question>Wann wollen Sie Ihre Vorsorge erledigen?</Question>
          <FormContainer>
            {this.renderAnswer(answer1, 'NOW')}
            {this.renderAnswer(answer2, 'WEEKS')}
            {this.renderAnswer(answer3, 'MONTHS')}
            {this.renderAnswer(answer4, 'UNSURE')}
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(TimeFrameInput)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/provision/TimeFrameInput.tsx